import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './AuthConfig';

export const msalInstance = new PublicClientApplication(msalConfig);
